// @flow
import React, { Fragment } from 'react';
import { Container, Row, Col } from 'Components/Grid';
import Button from 'Components/Button';
import styles from './styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

type Props = {
  nextLink: string,
  nextLabel: string,
  nextPreview?: string,
  prevLink: string,
  prevLabel: string,
  prevPreview?: string,
};

export default class FollowUp extends React.Component<Props> {
  render() {
    const { nextLink, nextLabel, nextPreview, prevLink, prevLabel, prevPreview } = this.props;

    const rootClass = cx('root', {
      empty: !prevLink && !nextLink,
    });

    return (
      <div className={rootClass}>
        <Container>
          <Row>
            <Col cols={12} m={6}>
              {prevLink && (
                <Fragment>
                  <Button href={prevLink} label={prevLabel} type="secondary" />
                  {prevPreview && <div className={styles.preview}>{prevPreview}</div>}
                </Fragment>
              )}
            </Col>

            <Col cols={12} m={6} className={styles.right}>
              {nextLink && (
                <Fragment>
                  <Button href={nextLink} label={nextLabel} type="secondary" />
                  {nextPreview && <div className={styles.preview}>{nextPreview}</div>}
                </Fragment>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
